export enum SearchType {
  Student = 'student',
  Activity = 'activity',
  Season = 'season'
}